import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ModalBaseComponent } from '../../../../gamma/core/components/modal-base.component';
import { IModalOptions } from '../../../../gamma/modal';
import { ToastService } from '../../../../gamma/toast';
import { UserAgentService } from '../../../../gamma/utils/user-agent.service';

import { U2000_SecurityService } from '../U2000_security.service';

export interface IU2000_VerifyEmailModalContext {
    email: string;
}

@Component({
    selector: 'u2000-verifyemail-modal',
    templateUrl: 'U2000_verifyemail-modal.component.html',
    styleUrls: ['U2000_verifyemail-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2000_VerifyEmailModalComponent extends ModalBaseComponent<U2000_SecurityService, string | HttpErrorResponse> implements OnInit {
    // Read by U2000_ModalProvider before the modal is created (size/backdrop can no longer be
    // mutated from this component's own constructor under ngx-bootstrap — see U2000_modal.provider.ts).
    static readonly modalDisplayOptions: IModalOptions = { backdrop: true };

    // Populated by ngx-bootstrap from ModalOptions.initialState.context — see
    // U2000_ModalProvider.openComponent.
    context: IU2000_VerifyEmailModalContext;

    constructor(
        public dialog: BsModalRef,
        service: U2000_SecurityService,
        toastService: ToastService,
        private el: ElementRef,
        public userAgentService: UserAgentService,
    ) {
        super(service, toastService);
    }

    ngOnInit() {
        const element: HTMLDivElement = this.el.nativeElement;
        const modalDialog = element.parentElement.parentElement;
        const modalContent = element.parentElement;

        modalDialog.className = 'modal-dialog u2000-verifyemail-dialog';
        modalContent.className = 'modal-content u2000-verifyemail-content';
    }

    onValid(securityKey: string) {
        this.result = securityKey;
        this.dialog.hide();
    }

    onError(error: HttpErrorResponse) {
        this.result = error;
        this.dialog.hide();
    }

    closeClick() {
        // `dialog.dismiss()` (ngx-modialog-7) has no BsModalRef equivalent — `hide()` without
        // setting `result` is the same "cancel" outcome (see U2000_ModalProvider.openComponent).
        this.dialog.hide();
    }
}
